export default function Chevron({ ...props }) {
  return (
    <svg viewBox="0 0 16.414 8.707" {...props}>
      <path d="m15.707.707-7.5 7.5-7.5-7.5" fill="none" />
    </svg>
  );
}
